// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,ts_nocheck=true"
// @generated from file einride/rd_operator_interface/v1/remote_interface_action_service.proto (package einride.rd_operator_interface.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { ActionResponse, ActionResponseSchema, RemoteInterfaceAction, RemoteInterfaceActionSchema } from "./remote_interface_action_pb";
import { file_einride_rd_operator_interface_v1_remote_interface_action } from "./remote_interface_action_pb";
import { file_google_api_annotations } from "../../../google/api/annotations_pb";
import { file_google_api_client } from "../../../google/api/client_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../../google/api/resource_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file einride/rd_operator_interface/v1/remote_interface_action_service.proto.
 */
export const file_einride_rd_operator_interface_v1_remote_interface_action_service: GenFile = /*@__PURE__*/
  fileDesc("CkZlaW5yaWRlL3JkX29wZXJhdG9yX2ludGVyZmFjZS92MS9yZW1vdGVfaW50ZXJmYWNlX2FjdGlvbl9zZXJ2aWNlLnByb3RvEiBlaW5yaWRlLnJkX29wZXJhdG9yX2ludGVyZmFjZS52MSKQAQobQ3JlYXRlQWN0aW9uUmVzcG9uc2VSZXF1ZXN0EiAKEmFjdGlvbl9yZXNwb25zZV9pZBgBIAEoCUIE4kEBAhJPCg9hY3Rpb25fcmVzcG9uc2UYAiABKAsyMC5laW5yaWRlLnJkX29wZXJhdG9yX2ludGVyZmFjZS52MS5BY3Rpb25SZXNwb25zZUIE4kEBAiKCAgoiQ3JlYXRlUmVtb3RlSW50ZXJmYWNlQWN0aW9uUmVxdWVzdBJSCgZwYXJlbnQYASABKAlCQuJBAQL6QTsKOXJkLW9wZXJhdG9yLWludGVyZmFjZS5hcGkuZWlucmlkZS5zeXN0ZW1zL1JlbW90ZUludGVyZmFjZRJeChdyZW1vdGVfaW50ZXJmYWNlX2FjdGlvbhgCIAEoCzI3LmVpbnJpZGUucmRfb3BlcmF0b3JfaW50ZXJmYWNlLnYxLlJlbW90ZUludGVyZmFjZUFjdGlvbkIE4kEBAhIoChpyZW1vdGVfaW50ZXJmYWNlX2FjdGlvbl9pZBgDIAEoCUIE4kEBASJrChhHZXRBY3Rpb25SZXNwb25zZVJlcXVlc3QSTwoEbmFtZRgBIAEoCUJB4kEBAvpBOgo4cmQtb3BlcmF0b3ItaW50ZXJmYWNlLmFwaS5laW5yaWRlLnN5c3RlbXMvQWN0aW9uUmVzcG9uc2Uy6QUKHFJlbW90ZUludGVyZmFjZUFjdGlvblNlcnZpY2USogIKG0NyZWF0ZVJlbW90ZUludGVyZmFjZUFjdGlvbhJELmVpbnJpZGUucmRfb3BlcmF0b3JfaW50ZXJmYWNlLnYxLkNyZWF0ZVJlbW90ZUludGVyZmFjZUFjdGlvblJlcXVlc3QaNy5laW5yaWRlLnJkX29wZXJhdG9yX2ludGVyZmFjZS52MS5SZW1vdGVJbnRlcmZhY2VBY3Rpb24igwHaQTlwYXJlbnQscmVtb3RlX2ludGVyZmFjZV9hY3Rpb24scmVtb3RlX2ludGVyZmFjZV9hY3Rpb25faWSC0+STAkE6F3JlbW90ZV9pbnRlcmZhY2VfYWN0aW9uIiYvdjEve3BhcmVudD1yZW1vdGVJbnRlcmZhY2VzLyp9L2FjdGlvbhKuAQoRR2V0QWN0aW9uUmVzcG9uc2USOi5laW5yaWRlLnJkX29wZXJhdG9yX2ludGVyZmFjZS52MS5HZXRBY3Rpb25SZXNwb25zZVJlcXVlc3QaMC5laW5yaWRlLnJkX29wZXJhdG9yX2ludGVyZmFjZS52MS5BY3Rpb25SZXNwb25zZSIr2kEEbmFtZYLT5JMCHhIcL3YxL3tuYW1lPWFjdGlvblJlc3BvbnNlcy8qfRLaAQoUQ3JlYXRlQWN0aW9uUmVzcG9uc2USPS5laW5yaWRlLnJkX29wZXJhdG9yX2ludGVyZmFjZS52MS5DcmVhdGVBY3Rpb25SZXNwb25zZVJlcXVlc3QaMC5laW5yaWRlLnJkX29wZXJhdG9yX2ludGVyZmFjZS52MS5BY3Rpb25SZXNwb25zZSJR2kEiYWN0aW9uX3Jlc3BvbnNlLGFjdGlvbl9yZXNwb25zZV9pZILT5JMCJjoPYWN0aW9uX3Jlc3BvbnNlIhMvdjEvYWN0aW9uUmVzcG9uc2VzGhbKQRNhcGkuZWlucmlkZS5zeXN0ZW1zYgZwcm90bzM", [file_einride_rd_operator_interface_v1_remote_interface_action, file_google_api_annotations, file_google_api_client, file_google_api_field_behavior, file_google_api_resource]);

/**
 * Request to create an action response
 *
 * @generated from message einride.rd_operator_interface.v1.CreateActionResponseRequest
 */
export type CreateActionResponseRequest = Message<"einride.rd_operator_interface.v1.CreateActionResponseRequest"> & {
  /**
   * ID of the action response. NOT the id that the response is refering the status of
   *
   * @generated from field: string action_response_id = 1;
   */
  actionResponseId: string;

  /**
   * Action response containing information about the status of an action
   *
   * @generated from field: einride.rd_operator_interface.v1.ActionResponse action_response = 2;
   */
  actionResponse?: ActionResponse;
};

/**
 * Describes the message einride.rd_operator_interface.v1.CreateActionResponseRequest.
 * Use `create(CreateActionResponseRequestSchema)` to create a new message.
 */
export const CreateActionResponseRequestSchema: GenMessage<CreateActionResponseRequest> = /*@__PURE__*/
  messageDesc(file_einride_rd_operator_interface_v1_remote_interface_action_service, 0);

/**
 * Request to CreateRemoteInterfaceActionRequest.
 *
 * @generated from message einride.rd_operator_interface.v1.CreateRemoteInterfaceActionRequest
 */
export type CreateRemoteInterfaceActionRequest = Message<"einride.rd_operator_interface.v1.CreateRemoteInterfaceActionRequest"> & {
  /**
   * Remote Interface resource name.
   *
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * Action request.
   *
   * @generated from field: einride.rd_operator_interface.v1.RemoteInterfaceAction remote_interface_action = 2;
   */
  remoteInterfaceAction?: RemoteInterfaceAction;

  /**
   * ID of the request. Must be a UUID. Used to track the state of an action (e.g. error, pending or success)
   *
   * @generated from field: string remote_interface_action_id = 3;
   */
  remoteInterfaceActionId: string;
};

/**
 * Describes the message einride.rd_operator_interface.v1.CreateRemoteInterfaceActionRequest.
 * Use `create(CreateRemoteInterfaceActionRequestSchema)` to create a new message.
 */
export const CreateRemoteInterfaceActionRequestSchema: GenMessage<CreateRemoteInterfaceActionRequest> = /*@__PURE__*/
  messageDesc(file_einride_rd_operator_interface_v1_remote_interface_action_service, 1);

/**
 * A request to see the status of an action
 *
 * @generated from message einride.rd_operator_interface.v1.GetActionResponseRequest
 */
export type GetActionResponseRequest = Message<"einride.rd_operator_interface.v1.GetActionResponseRequest"> & {
  /**
   * Resource name (request_id) of the action status to retrieve.
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message einride.rd_operator_interface.v1.GetActionResponseRequest.
 * Use `create(GetActionResponseRequestSchema)` to create a new message.
 */
export const GetActionResponseRequestSchema: GenMessage<GetActionResponseRequest> = /*@__PURE__*/
  messageDesc(file_einride_rd_operator_interface_v1_remote_interface_action_service, 2);

/**
 * Remote interface action service.
 * Linter disabled to remove the need to create ListActionResponses
 * (-- api-linter: core::0121::resource-must-support-list=disabled --)
 *
 * @generated from service einride.rd_operator_interface.v1.RemoteInterfaceActionService
 */
export const RemoteInterfaceActionService: GenService<{
  /**
   * Get a remote interface.
   * (-- api-linter: core::0133::method-signature=disabled
   *     aip.dev/not-precedent: We don't adhere to AIP-121 with resource-based design. --)
   *
   * @generated from rpc einride.rd_operator_interface.v1.RemoteInterfaceActionService.CreateRemoteInterfaceAction
   */
  createRemoteInterfaceAction: {
    methodKind: "unary";
    input: typeof CreateRemoteInterfaceActionRequestSchema;
    output: typeof RemoteInterfaceActionSchema;
  },
  /**
   * Get a action response, i.e. the status of an action
   *
   * @generated from rpc einride.rd_operator_interface.v1.RemoteInterfaceActionService.GetActionResponse
   */
  getActionResponse: {
    methodKind: "unary";
    input: typeof GetActionResponseRequestSchema;
    output: typeof ActionResponseSchema;
  },
  /**
   * Create a action response. Usually called by ri-manager
   *
   * @generated from rpc einride.rd_operator_interface.v1.RemoteInterfaceActionService.CreateActionResponse
   */
  createActionResponse: {
    methodKind: "unary";
    input: typeof CreateActionResponseRequestSchema;
    output: typeof ActionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_einride_rd_operator_interface_v1_remote_interface_action_service, 0);

